// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updatePartReturnsStatus = (status, isSelected) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            isSelected,
            status,
            type: actions.UPDATE_USER_PREFERENCES_PART_RETURNS_STATUS
        });

    };

export const updatePartReturnsNumberOfDays = numberOfDays =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            numberOfDays,
            type: actions.UPDATE_USER_PREFERENCES_PART_RETURNS_NUMBER_OF_DAYS
        });

    };

export const toggleAllPartReturnsStatus = statusList =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            statusList,
            type: actions.UPDATE_USER_PREFERENCES_ALL_PART_RETURNS_STATUS
        });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/part-returns-settings.js